import React, { Component } from "react";
import { Popover, Overlay } from 'react-bootstrap';
import { TableButton } from '../../TableButton';

export class PopoverForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showPopover: false,
        }
    }

    componentWillUnmount() {
        this.setState({
            showPopover: false
        });
    }

    onChildrenClick() {
        const { showPopover } = this.state;

        this.setState({
            showPopover: !showPopover
        });
    }

    onOptionClick(callback) {
        this.setState({
            showPopover: false
        });

        if ("function" === typeof callback) {
            callback();
        }
    }

    renderPopover() {
        const { showPopover } = this.state;
        const { pt } = this.props;

        if (showPopover) {
            const isMoveDisabled = pt.wasReplaced === true;

            return (
                <Overlay rootClose show={showPopover} target={this} placement="bottom" onHide={() => this.onChildrenClick()}>
                    <Popover id="popover-trigger-focus" title={`Opções - Viagem ${pt.name === undefined ? pt.code : pt.name}`}>
                        <div className="d-flex align-items-center justify-content-center" onClick={() => this.onOptionClick(this.props.handleIntervalsClick(this.props.pt))}>
                            <TableButton icon="icon-manage-uptime" title="Periodos de Funcionamento" />
                            <p className="text-align-left" style={{ margin: '4px 3px 3px', cursor: 'pointer' }}> Periodos de Funcionamento </p>
                        </div>
                        <div className="d-flex align-items-center justify-content-center" onClick={() => this.onOptionClick(this.props.handleNotesClick(this.props.pt))}>
                            <TableButton icon="icon-lines" title="Notas" />
                            <p className="text-align-left" style={{ margin: '3px 3px 3px', cursor: 'pointer' }}> Notas </p>
                        </div>
                        <div className="d-flex align-items-center justify-content-center"
                            onClick={isMoveDisabled ? undefined : () => this.onOptionClick(this.props.handleMoveClick(this.props.pt))}
                            style={isMoveDisabled ? { opacity: 0.5, pointerEvents: 'none' } : {}}>
                            <TableButton icon="icon-network" title="Mover Viagem" disabled={isMoveDisabled} />
                            <p className="text-align-left" style={{ margin: '3px 3px 3px', cursor: isMoveDisabled ? 'not-allowed' : 'pointer' }}> Mover </p>
                        </div>
                        <div className="d-flex align-items-center justify-content-center" onClick={() => this.onOptionClick(this.props.handleCopyClick(this.props.pt))} >
                            <TableButton icon="icon-copy" title="Copiar Viagem" />
                            <p className="text-align-left" style={{ margin: '3px 3px 3px', cursor: 'pointer' }}> Copiar </p>
                        </div>
                    </Popover>
                </Overlay>
            );
        }

        return null;
    }


    render() {
        return (
            <React.Fragment>
                {React.cloneElement(this.props.children, { onClick: () => this.onChildrenClick() })}
                {this.renderPopover()}
            </React.Fragment>
        );
    }
}